import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/Product1'
            },
            {
              path: '/software/Product1',
              name: 'software',
              component: resolve => require(['@/view/Product1'], resolve),
              meta: {
                title: '产品丨储能逆变器'
              }
            },
            {
              path: '/software/Product2',
              name: 'software',
              component: resolve => require(['@/view/Product2'], resolve),
              meta: {
                title: '产品丨储能一体机'
              }
            },
            {
              path: '/software/Product3',
              name: 'software',
              component: resolve => require(['@/view/Product3'], resolve),
              meta: {
                title: '产品丨通讯控制附件产品'
              }
            }
          ]
        }, {
          path: '/serviceSupport',
          name: 'serviceSupport',
          component: resolve => require(['@/view/serviceSupport'], resolve),
          meta: {
            title: '服务支持'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/downloadcenter',
          name: 'downloadcenter',
          component: resolve => require(['@/view/DownloadCenter'],resolve),
          meta: {
            title: '下载中心'
          }
        },
        {
          path: '/onlinesupport',
          name: 'onlinesupport',
          component: resolve => require(['@/view/OnlineSupport'],resolve),
          meta: {
            title: '线上支持'
          }
        },
        {
          path: '/frequentlyquestions',
          name: 'frequentlyquestions',
          component: resolve => require(['@/view/FrequentlyQuestions'],resolve),
          meta: {
            title: '常见问题'
          }
        },
        {
          path: '/ProjectCases',
          name: 'ProjectCases',
          component: resolve => require(['@/view/ProjectCases'],resolve),
          meta: {
            title: '项目案例'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js